import './sub-components/al-user-grid-entry/component';
import template from './component.tpl.html';
import AlUsersGridViewController from './controller';

angular
    .module('festzelt-os.modules.guestlists')
    .component('alUsersGridView', {
        bindings: {
            hideHeader: '<',
            onSwitchToListView:'&'
        },
        controller: AlUsersGridViewController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/users/components/al-users-grid-view/component.js